import classNames from 'classnames';
import { isFuture, isPast, isToday } from 'date-fns';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { EventProps } from 'react-big-calendar';
import { PiCassetteTapeBold, PiHeadphonesBold } from 'react-icons/pi';
import { PRODUCT_TYPE } from 'services/contract/types';
import { IMusicProductRelease } from 'services/music-product-digital/types/query';
import './ProductReleaseCalendarEvent.scss';

const ProductReleaseCalendarEvent = ({
  event,
}: EventProps<IMusicProductRelease>) => {
  const navigate = useNewWindowNavigate();
  return (
    <div
      className={classNames([
        'product-release-calendar-event',
        {
          today: isToday(event.releaseDate),
          past: !isToday(event.releaseDate) && isPast(event.releaseDate),
          future: isFuture(event.releaseDate),
        },
      ])}
      title={event.title.title}
      onClick={() =>
        navigate(
          `${
            event.productType.id === PRODUCT_TYPE.Digital
              ? 'music-product-digital'
              : 'music-product-physical'
          }/${event.id}/contracts`
        )
      }>
      {event.productType.id === PRODUCT_TYPE.Digital ? (
        <PiHeadphonesBold />
      ) : (
        <PiCassetteTapeBold />
      )}
      <div>{event.title.title} </div>
      {!!event.title.version?.length && <p>{event.title.version}</p>}
    </div>
  );
};

export default ProductReleaseCalendarEvent;
